export default __webpack_public_path__ + "static/media/pig.e78d1f13.png";